<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<!-- <div id="loginId" class="row loginCss">
  <div class="form-group col-md-12 p-0">
    <section class="content-header login-header header-bg">
      <h1 style="color:white !important">
        <strong>Sign In To Your Account</strong>
      </h1>
    </section>
    <section class="login-popup">
      <div class="row">
        <div class="col-lg-12">
          <form id="loginForm" name="loginForm" #loginForm="ngForm">
            <div class="form-group col-lg-12">
              <div class="col-md-6 input-container">
                <ds-icon name="person" size="inherit" class="icon-input border-radius"></ds-icon>
                <input type="text" class="form-control form-data input-field border-radius-none" placeholder="User Name" name="UserName" #userName="ngModel" [(ngModel)]="User.UserName" id="userName">
              </div>
            </div>
            <div class="form-group col-lg-12">
              <div class="col-md-6 input-container">
                <ds-icon name="key" size="inherit" class="icon-input border-radius"></ds-icon>
                <input type="password" class="form-control form-data input-field border-radius-none" placeholder="Password" name="Password" #password="ngModel" [(ngModel)]="User.Password" id="password" />
              </div>
            </div>
            <div class="login-footer">
              <div class="row">
                <div class="col-md-12" style="padding: 0px 40px;">
                  <div class="col-md-6 col-xs-6" style="margin-bottom: 10px;margin-top:10px;padding-left:0">
                    <a href="#" data-toggle="modal" data-target="#forgetPassword">Forgot Password?</a>
                  </div>
                  <div class="col-md-6 col-xs-6 p-0">
                    
                       <button type="submit" name="create" (click)="loginMe()" class="flat-butt flat-info-butt flat-info-grad-butt" style="font-size: 16px;float:right; margin-top: 5px; height: 30px;">Sign In</button>
     
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="text-align: center;margin-top:10px;">
             
                  <img src="../../assets/img/SignInwithMS.png" class="google-img" style="height: 46px; " />
              
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</div>


<div class="modal" id="forgetPassword">
  <div class="modal-dialog">
    <div class="modal-content add-attachment-content">

      <div class="modal-header" id="topHeader">
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close"><ds-icon name="close" size="inherit"></ds-icon></button>
        <h4 class="modal-title" id="login_title" style="float:left;font-weight:bold;">Password Recovery</h4>
      </div>
      <div class="modal-body">
        <div class="row">

          <form id="changeId" name="loginForm" #loginForm="ngForm">

            <div class="form-group col-lg-12">
              <label>Email Id:</label>
              <div class="input-container">
                <input type="email" class="form-control input-field border-radius-none" name="Email" />
              </div>
            </div>
            
            <div class="modal-footer">
              <button class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10" data-dismiss="modal">Cancel</button>
              <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" type="submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
 -->
